import React from 'react'

import DatesVariant from './Common/DatesVariant'
import SummaryCardImage from './SummaryCardImage'

import TripItemSummary from 'tripPlanner/components/TripModal/TripItems/Summary'
import useCanEditTrip from 'tripPlanner/hooks/useCanEditTrip'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'
import { CruiseItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: CruiseItem
}

function CustomCruise({ item }: Props) {
  const {
    isBooked,
    startPlace,
    name,
    type,
    startDate,
    endDate,
    startDay,
    endDay,
  } = item

  const openModal = useOpenModal()
  const onClick = () => openModal(TripItemSummary, { item })
  const canEdit = useCanEditTrip()

  return (
    <>
      <SummaryCardImage
        place={startPlace}
        tripId={item.tripId}
        tripItemId={item.id}
      />
      <DatesVariant
        region={startPlace.region}
        name={name}
        startDate={startDate}
        endDate={endDate}
        type={type}
        isBooked={isBooked}
        onClick={onClick}
        canEdit={canEdit && !isBooked}
        startDay={startDay}
        endDay={endDay}
      />
    </>
  )
}

export default CustomCruise
